var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Accounts Receivable")]),_c('ul',[_c('li',[_vm._v("List of unpaid receivables")]),_c('li',[_vm._v("List of paid receivables")]),_c('li',[_vm._v("Facilty to record payment by customer")]),_c('li',[_vm._v("Future: integration with bank account to record payment automatically")])])])
}]

export { render, staticRenderFns }